/**
 * Application-wide constants. Anything "magic" (route paths, storage keys,
 * enum display metadata) lives here so it is defined exactly once.
 */

/** Client-side route paths. */
export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',
  CATALOG: '/catalog',
  CATALOG_ADD: '/catalog/new',
  CATALOG_EDIT: '/catalog/:catalogId/edit',
  ORDERS: '/orders',
  INSTORE_SALE: '/in-store',
  INVENTORY: '/inventory',
  EARNINGS: '/earnings',
  SHOP: '/shop',
  STAFF: '/staff',
  BANK: '/bank',
};

/** Build the edit-product path for a given catalog id. */
export const catalogEditPath = (catalogId) => `/catalog/${catalogId}/edit`;

/** Keys used for persisting auth state in localStorage. */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'quro_vendor:auth_token',
  REFRESH_TOKEN: 'quro_vendor:refresh_token',
  USER: 'quro_vendor:user',
  ACTIVE_SHOP: 'quro_vendor:active_shop_id',
};

/**
 * Display metadata for order statuses. `tone` maps to a <Badge> variant.
 * Unknown statuses fall back to a humanised label with a neutral tone
 * (see `getOrderStatusMeta`), so the UI never breaks on a new enum value.
 */
export const ORDER_STATUS_META = {
  PENDING: { label: 'Pending', tone: 'warning' },
  PLACED: { label: 'Placed', tone: 'info' },
  ACCEPTED: { label: 'Accepted', tone: 'info' },
  CONFIRMED: { label: 'Confirmed', tone: 'info' },
  PREPARING: { label: 'Preparing', tone: 'brand' },
  READY_FOR_PICKUP: { label: 'Ready for pickup', tone: 'brand' },
  SHIPPED: { label: 'Shipped', tone: 'brand' },
  OUT_FOR_DELIVERY: { label: 'Out for delivery', tone: 'brand' },
  DELIVERED: { label: 'Delivered', tone: 'success' },
  COMPLETED: { label: 'Completed', tone: 'success' },
  CANCELLED: { label: 'Cancelled', tone: 'danger' },
  REJECTED: { label: 'Rejected', tone: 'danger' },
  RETURNED: { label: 'Returned', tone: 'neutral' },
  REFUNDED: { label: 'Refunded', tone: 'neutral' },
};

/** Default page size for paginated lists. */
export const DEFAULT_PAGE_SIZE = 10;
